// extracted by mini-css-extract-plugin
export var columnItem = "_bl-3";
export var columnItemDraggable = "_bl-4";
export var dragHandle = "_bl-0";
export var dragHandleHovered = "_bl-1";
export var dropdown = "_bl-5";
export var dropdownContent = "_bl-7";
export var dropdownInner = "_bl-6";
export var filterDropdownHeader = "_bl-8";
export var icon = "_bl-2";
export var sectionDivider = "_bl-9";